// extracted by mini-css-extract-plugin
export default {"noticeWrap":"notice-setting_noticeWrap__cwjcd","boxButtonWrap":"notice-setting_boxButtonWrap__BHLlv","boxButton":"notice-setting_boxButton__OKlaq"};